import React, { useEffect, useState, useContext } from 'react';
import { useParams, NavLink } from 'react-router-dom';
import Header from "../Header";
import Footer from "../Footer";

import { db, storage } from "../../firebase";
import { ref, getDownloadURL, uploadBytesResumable, deleteObject, uploadString } from "firebase/storage";
import { doc, collection, query, orderBy, where, getDoc, getDocs, updateDoc, addDoc } from "firebase/firestore";

import { ReactComponent as Question } from '../../assets/info_question.svg';

import { AuthContext } from '../../context/AuthContext';
import { useForm } from 'react-hook-form';

import Premium from "../Premium";

export default function Profile () {

	const [message, changeMessage] = useState('');
    const setMessage = (text) => {
        changeMessage(text)
        setTimeout(() => {
            changeMessage();
        }, 3000);
    };

	const { currentUser, user, setUser } = useContext(AuthContext);

	const {
        register,
        reset,
        handleSubmit,
        formState: { errors },
    } = useForm({

    });

	//===================================

	const Save = async (data) => {

// 		console.log(data);
// 		console.log(currentUser);
// 		console.log(user);

		if (currentUser){

			let userData = {
				first_name: data['first_name'],
				last_name: data['last_name'],
				company: data['company'],
				phone: data['phone'],
			}

			if (user.id) {
				const user_ref = await doc(db, "admins", user.id);
				await updateDoc(user_ref, userData).then((docRef) => {
					setMessage('Successfully');
				});

			} else {
				userData['user'] = currentUser;
				await addDoc(collection(db, "admins"), userData).then((docRef) => {
					setMessage('Successfully');

					user['first_name'] = data['first_name'];
					user['last_name'] = data['last_name'];
					user['company'] = data['company'];
					user['phone'] = data['phone'];
					setUser(Object.assign({}, user));
				});
			}
		}
	}
	//=====================
	// show premium popup

	const [showPremium, setShowPremium] = useState(false);



    return (

        <div className="page page_profile">

            <Header />

            {user['email'] ?

                <main>
                    <div className="content">

                        <ul className="breadcrumbs">
                            <li>
                                <a href="/">Home</a>
                            </li>
                            <li>
                                <span>Profile</span>
                            </li>
                        </ul>

                        <div className="page__title">
                            <h1>Profile</h1>
                            <div className="title__buttons">

                                {/*
								<a className="button" onClick={ () => { navigate("/project/"+projectID) }}>View project</a>
								<a className="button button_edit" onClick={ () => { navigate("/edit/"+projectID) }}>Edit project</a>
								*/}

                            </div>
                        </div>

                        <div className="columns">
                            <div className="column">
                                <section className="dashed-border profile">

									<div className="left">
										<div className="block">
											<div className="title">First name</div>
											<input
												type="text"
												{...register("first_name", { required: "First name is required", value: user['first_name'] })}
												placeholder={"First name"}
												defaultValue={user['first_name']}
											/>
											<div className="error">{errors['first_name'] ? errors['first_name']?.message : ''}</div>
										</div>

										<div className="block">
											<div className="title">Last name</div>
											<input
												type="text"
												{...register("last_name", { required: "Last name is required", value: user['last_name'] })}
												placeholder={"Last name"}
												defaultValue={user['last_name']}
											/>
											<div className="error">{errors['last_name'] ? errors['last_name']?.message : ''}</div>
										</div>

										<div className="block">
											<div className="title">Company</div>
											<input
												type="text"
												{...register("company")}
												placeholder={"Company"}
												defaultValue={user['company']}
											/>
											<div className="error">{errors['company'] ? errors['company']?.message : ''}</div>
										</div>
									</div>

									<div className="right">

										<div className="block">
											<div className="title">Email</div>
											<div className="email">
												<div className="text">
													{user['email']}
												</div>

												{user['emailVerified'] &&
													<div className="text verified">
														email verified
													</div>
												}
											</div>
										</div>

										<div className="block">
											<div className="title">Phone number</div>
											<input
												type="text"
												{...register("phone", {
													required: {
														value: true,
														message: "Please add your mobile phone number"
													},
													pattern: {
														value: /^\+[0-9]{11}$/,
														message: "This is not a valid mobile phone, format +12345678900"
													},
												})}


												{...register("phone", { required: "Phone is required", value: user['phone'] })}
												placeholder={"Phone number"}
												defaultValue={user['phone']}
											/>
											<div className="error">{errors['phone'] ? errors['phone']?.message : ''}</div>
										</div>

										{/*
										<div className="block">
											<div className="title">Photo ??</div>
											<div>
												{user['photoURL']}
											</div>
										</div>
										*/}

										<div className="block">
											<div className="title">Account type</div>
											<div className="text account">
												{user['account'] ?
													user['account']
													:
													'free'
												}
												{(user['account'] == 'free' || !user['account']) &&
													<div className="question" onClick={() => {setShowPremium(true)}}>
														<Question />
													</div>
												}
											</div>
										</div>

									</div>



                                </section>
                            </div>

                            <div className="buttons">
								<button className="button_publish button" onClick={handleSubmit(Save)}>
									Save
								</button>

								{!(user['providerData'].length == 1 && user['providerData'][0]['providerId'] == 'google.com') &&

									<NavLink to="/change-password">
										Change password
									</NavLink>
								}

							</div>

							<div className="error submit_error">{message}</div>



                        </div>


                    </div>
                </main>

                :

                <>
					...Загрузка...
                </>
            }

            <Footer />

            {
                showPremium &&
                    <Premium setShowPremium={setShowPremium} />
            }

        </div>

    )

}
